import React, { useState } from "react";
import closeIcon from "../../assets/svg/close_x.svg";
import downIcon from "../../assets/svg/arrow-down.svg";
import DropdownCard from "components/atoms/Dropdown/DropdownCard";
import { ToFirstLetters } from "components/atoms/CaseManager";

type Props = {
  titleText?: string;
  filterData: any[];
  filterStyle?: string;
  dropdownStyle?: string;
  selected: string;
  setSelected: (data: any) => void;
};

const SelectFilter = (props: Props) => {
  const [dropdown, setDropdown] = useState(false);

  const handleSelect = (item) => {
    props.setSelected(item.value);
    setDropdown(false);
  };

  return (
    <div className="relative">
      <div
        className={`${props.filterStyle} ${
          props.selected !== "" && "border-Primary"
        } border overflow-hidden relative z-[15] bg-white border-dashed rounded-[5px] flex justify-between items-center`}
      >
        <span
          className="p-2 text-sm font-normal leading-6 truncate cursor-pointer desktop:text-base mobile:text-xs text-Black2"
          onClick={() => setDropdown(true)}
        >
          Filter by{" "}
          {props.selected === ""
            ? props.titleText
            : props.selected?.split("_").join(" ")}
        </span>
        {props.selected !== "" && (
          <span className="relative z-20 p-2 cursor-pointer">
            {/* <img src={closeIcon} alt='remove_filter' className='w-4 h-4' onClick={}/>
                    <img src={downIcon} alt='remove_filter' className='w-4 h-4' onClick={}/> */}

            {/* <img src={dropdown ? closeIcon : downIcon} alt='remove_filter' className='w-4 h-4' onClick={
                        dropdown 
                        ?   () => {
                            props.setSelected('');
                            setDropdown(false);
                        } 
                        
                        : () => {}} 
                    /> */}

            <img
              src={closeIcon}
              alt="remove_filter"
              className="w-4 h-4"
              onClick={() => props.setSelected("")}
            />
          </span>
        )}
      </div>
      {dropdown && (
        <DropdownCard
          handleClickOut={setDropdown}
          cardLayout={`${props.dropdownStyle} max-h-[150px] overflow-y-scroll flex flex-col gap-2 absolute z-10 tablet:z-20 right-0 top-12 p-1 bg-white rounded-md shadow-[0_8px_30px_rgb(0,0,0,0.12)] w-full h-fit animate-slide_down2`}
        >
          {props.filterData.map((item, i) => (
            <span
              key={i}
              className="p-2 text-sm font-normal leading-6 rounded-md cursor-pointer desktop:text-base mobile:text-xs text-Black2 hover:bg-BackDrop_d_xs"
              onClick={() => handleSelect(item)}
            >
              {item.label}
            </span>
          ))}
        </DropdownCard>
      )}
    </div>
  );
};

export default SelectFilter;
